
window.ECV_CONFIGURATION='VF_MOBILE';
console.log("ECV CONFIGURATION = VF_MOBILE");
let modules = [
import('../modules/CoreModules/Demo'),
import('../modules/CoreModules/PureWebRTC'),
import('../modules/CoreModules/ExternalAdapter'),
import('../modules/CoreModules/Photo'),
import('../modules/CustomerModules/Vodafone/Mobile/Disabled'),
import('../modules/CustomerModules/Vodafone/Mobile/Vip'),];
export default modules;